// extracted by mini-css-extract-plugin
export default {"container":"AboutCard_container__FCJwp","description":"AboutCard_description__l5oNz","divider":"AboutCard_divider__qoYZ1","markdown":"AboutCard_markdown__qG-oC"};